import React from 'react';
import {TouchableOpacity, StyleSheet, Text} from 'react-native';
import colors from '../config/colors';

function AppButton({
  title,
  onPress,
  color = 'green',
  style,
  textColor = 'white',
  textWeight = '600',
}) {
  return (
    <TouchableOpacity
      style={[styles.button, {backgroundColor: colors[color]}, style]}
      onPress={onPress}>
      <Text
        style={{
          textAlign: 'center',
          textAlignVertical: 'center',
          color: colors[textColor],
          fontWeight: textWeight,
          // textTransform: "uppercase",
        }}>
        {title}
      </Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  button: {
    backgroundColor: colors.green,
    minHeight: 40,
    justifyContent: 'center',
    width: 100,
    borderRadius: 8,
    // shadowOpacity: 0.4,
    // shadowColor: "darkgray",
    // shadowOffset: { width: 8, height: 8 },
    // shadowRadius: 10,
    // elevation: 20,
  },
});

export default AppButton;
